import { createStyles } from "@mantine/core";


const useStyles = createStyles((theme) => ({
  wrapper: {
  display: "flex",
  background: "white",
  minHeight: "100vh", // ✅
},

  content: {
  display: "flex",
  width: "100%",
  flexDirection: "column",
  background: "#F5F5F5",
  minHeight: "100vh",   // ✅ correct
  overflowX: "hidden", // ✅
},

  btn: {
  marginTop: 20,
  marginBottom: 20,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  flexWrap: "wrap", // allow wrapping on small screens

  // Responsive: move button below tabs but keep it on right
  [`@media (max-width: 768px)`]: {
    flexDirection: "column", // stack vertically
    alignItems: "end",    // stretch tabs full width
    gap: 12,                  // spacing between tabs and button
  },
},


  mymodal: {
    width: 818,
    "& .mantine-Modal-inner": {
      padding: "0px !important",
    },
  },
  mwd: {
    width: "100%",
  },
  pagination: {
    marginTop: "auto",
    display: "flex",
    alignItems: "end",
    justifyContent: "end",
  },

  container: {
    width: "100%",
    backgroundColor: "#F5F5F5",
    height: "100%"
  },

  createMenuBtn: {
  padding: 12,
  cursor: "pointer",
  borderRadius: "8px",
  border: "1px solid #FFAF4A",
  backgroundColor: "#FFAF4A",
  boxShadow: "0 1px 2px 0 rgba(16, 24, 40, 0.05)",
  height: 48,

  // Push to right when wrapped
  [`@media (max-width: 768px)`]: {
    marginLeft: "auto",
  },

  "& .arrowBox": {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    width: 30,
    borderLeft: "2px solid #1D2939",
  },
},

  menuDropdown: {
    padding: 8,
    borderRadius: 4,
    backgroundColor: "#FFF",
    boxShadow: "0 2px 8px 0 rgba(0, 0, 0, 0.10)",
  },
  menuDropdownItem: {
    padding: "4px 12px",
    ":hover": {
      backgroundColor: "#F4F4F5",
      borderRadius: 4,
    },
  },

  tabButton: {
  backgroundColor: "#F3F4F6",
  color: "#374151",
  fontWeight: 500,
  fontSize: 14,
  padding: "8px 18px",
  borderRadius: 8,
  border: "1px solid transparent",
  transition: "all 0.2s ease",

  "&:hover": {
    backgroundColor: "#E5E7EB",
  },

  // ACTIVE TAB STYLE → this makes it look like reference buttons
  '&[data-active="true"]': {
    backgroundColor: "#FFFFFF",
    color: "#111827",
    border: "1px solid #D1D5DB",
    boxShadow:
      "0px 1px 2px rgba(0,0,0,0.06), 0px 1px 3px rgba(0,0,0,0.1)",
  },
},

tabs: {
    "& .mantine-Tabs-tabsList": {
      borderRadius: "8px",
      backgroundColor: "#FFF",
      padding: "16px 12px 02px 12px",
      border: "none",
      gap: 16,
      "& .mantine-Tabs-tab": {
        padding: "8px 16px",
        lineHeight: "20px",
        background: "#fff",
        borderRadius: "0px",
        color: "#737373",
        fontFamily: "Inter",
        fontSize: "14px",
        fontWeight: 500,
        "&:hover": {
          borderColor: "none",
        },
        "&[data-active]": {
          color: "#262626 !important",
          backgroundColor: "#FFF !important",
          borderBottom: "2px solid #171717 !important",
        },
      }
    },
  },

}));

export default useStyles;